










import { Component, Mixins } from "vue-property-decorator";
import { StandardOption } from "../../system/selectors/mixins";
import OptionDropDownSelector from "../../system/selectors/OptionDropDownSelector.vue";
import ConfigurationEditor from "./store/ConfigurationEditor.vue";
import DepartmentEditor from "./store/DepartmentEditor.vue";

@Component({
  components: {
    OptionDropDownSelector,
    ConfigurationEditor,
    DepartmentEditor,
  }
})
export default class StoreEditor extends Mixins() {
  data(): any {
    return {
      contents: [
        new StandardOption<string>("configuration", "configuration-editor"),
        new StandardOption<string>("department", "department-editor"),
      ],
      selectedContent: "configuration-editor",
    };
  }
  contents: StandardOption<string>[];
  selectedContent: string;

  selectContent(key: string): void {
    this.selectedContent = key;
  }
}
